import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="bg-background-100">
      <div className="container-site py-14 md:py-20">
        <div className="relative overflow-hidden rounded-lg bg-primary-800 px-6 py-12 md:px-12 md:py-16">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/70 to-primary-700/40"></div>
          <div className="relative max-w-2xl">
            <h2 className="font-heading text-2xl font-bold leading-tight text-background-50 md:text-3xl">
              想按系列或作者批量收藏？
            </h2>
            <p className="mt-3 text-sm leading-6 text-background-100 md:text-base">
              直接查归档列表即可，省去零散收藏的麻烦。整理贴会持续补全并更新目录，随时查都能找到最新整理。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/archive"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-archive-line mr-2"></i>
                查看归档列表
              </Link>
              <Link
                to="/collections"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 bg-transparent px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览合集
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}